import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import WaiverTemplates from '../../components/history/modals/WaiverTemplates';
import FileMaintenance from '../../components/common/modals/FileMaintenance';

const MaintenancePage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Maintenance</Typography>
            <List>
              <WaiverTemplates />
              <FileMaintenance />
            </List>
        </>
    );
};

export default MaintenancePage;
